import {
  Button,
  Label,
  ListBox,
  ListBoxItem,
  Popover,
  Select,
  SelectValue,
} from 'react-aria-components'

import ChevronDownSvg from '@/assets/icons/chevron-down.svg?react'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './QuantitySelector.module.scss'

interface Props {
  quantity: number
  setQuantity: MemoizedCallbackOrDispatch<number>
  allowZero?: boolean
  maxQuantity?: number
}

export default memo(function QuantitySelector({
  quantity,
  setQuantity,
  allowZero,
  maxQuantity,
}: Props) {
  const maxQty = maxQuantity ?? 10

  const onSelectionChange = useCallback(
    (q: string | number) => {
      setQuantity(Number(q))
    },
    [setQuantity],
  )

  return (
    <Select className={style.Select} selectedKey={quantity} onSelectionChange={onSelectionChange}>
      <VisuallyHidden as={Label}>Quantity</VisuallyHidden>
      <Button className={style.SelectButton}>
        {/* <span aria-hidden>Qty:</span> */}
        <SelectValue className={style.Value} />
        <span aria-hidden className={style.Chevron}>
          <ChevronDownSvg
            className={style.ChevronIcon}
            width={12}
            height={16}
            viewBox='0 0 24 24'
            aria-hidden
          />
        </span>
      </Button>
      <Popover className={style.SelectList}>
        <ListBox className={style.ListBox}>
          {allowZero && (
            <ListBoxItem className={style.ListBoxItem} key={0} id={0} textValue={String(0)}>
              0 (Remove)
            </ListBoxItem>
          )}
          {new Array(Math.max(maxQty, quantity)).fill(0).map((_, i) => (
            <ListBoxItem
              className={style.ListBoxItem}
              key={i + 1}
              id={i + 1}
              textValue={String(i + 1)}
            >
              {i + 1}
            </ListBoxItem>
          ))}
        </ListBox>
      </Popover>
    </Select>
  )
})
